import styled, { keyframes } from "styled-components";
import { StyledWrapperProps } from "./types";

export const StyledWrapper = styled.div<StyledWrapperProps>`
  min-width: calc(100vw - 360px);
  height: 100vh;
  position: static;
  opacity: 0.7;
  overflow: hidden;
`;

const move = keyframes`
from{
    left: -100%;
}
to{
    left: 100%;
}`;

export const StyledWalkerBackground = styled.div`
  min-width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.secondary};
`;

export const StyledWalker = styled.div`
  min-width: inherit;
  height: 100%;
  position: absolute;
  background-color: ${({ theme }) => theme.colors.secondary};
  background: linear-gradient(90deg, #e6f3ff 1%, #9ec4e7 50%, #e6f3ff 100%);
  animation: ${move} 1s infinite;
`;
